<template>
  <div>
    <p v-if="time" :class="['tw-mb-1.5 tw-text-ugray-600 tw-text-xs tw-leading-4.5', sendByMe ? 'tw-text-right' : '']">{{time}}</p>
    <div
      :title="message.createdAtForTitle"
      :class="['tw-py-2.5 tw-px-3.5 tw-w-max tw-rounded-lg tw-text-sm tw-ugray-800 tw-flex tw-items-end tw-mb-2 tw-gap-2 tw-leading-5', sendByMe ? 'tw-bg-ublue-100 tw-ml-auto tw-rounded-tr-none' : 'tw-bg-ugray-50 tw-border tw-border-ugray-200 tw-mr-auto tw-rounded-tl-none' ]"
      style="max-width: 100%;">
      <div class="tw-break-all" v-html="message.content"></div>
      <message-status :status="message.status" v-if="sendByMe" />
    </div>
  </div>
</template>

<script>
import MessageStatus from "./message-status.vue"
export default {
  props: ["message", "sendByMe", "time"],
  components: {MessageStatus}
};
</script>
